import React from 'react';
import { useTranslation } from 'react-i18next';
import { BodyText, Flex, Table, Tag } from '@gaiads/telia-react-component-library';
import { LocalProductVariant } from '@cdaas/api-clients/dist/product-service-openapi';

import { Availability } from '../../../shared/ListUtil/Availability';

interface MainListItemProps {
  item: LocalProductVariant;
}

const MainListItem = ({ item }: MainListItemProps) => {
  const { t } = useTranslation('bundlesview');
  const { name, available_amount } = item;
  return (
    <Table.Row className="telia-react-table_row__child">
      <Table.Cell></Table.Cell>
      <Table.Cell></Table.Cell>
      <Table.Cell></Table.Cell>
      <Table.Cell className="daas-product-table__name">
        <Flex>
          <Flex flexItem>
            <BodyText>{name}</BodyText>
          </Flex>
          <Flex flexItem>
            <Tag className={'telia-react-table_row__variants'} backgroundColor={'purple500'}>
              {t('bundles_table.main')}
            </Tag>
          </Flex>
        </Flex>
      </Table.Cell>
      <Table.Cell className="daas-product-table__availability">
        <Availability availableAmount={available_amount} />
      </Table.Cell>
      <Table.Cell></Table.Cell>
      <Table.Cell></Table.Cell>
      <Table.Cell></Table.Cell>
      <Table.Cell></Table.Cell>
      <Table.Cell></Table.Cell>
    </Table.Row>
  );
};

export default MainListItem;
